import { memo, Fragment, useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import Logo from '@hiredigital/ui/Logo';
import Menu from './components/Default';
// import Enterprise from './components/Enterprise';

import { Types } from './constants';
import Styles from './Header.module.scss';

/*
  There are two types of heroes. One for hero pages (dark background) and pages (light background)
  There are several variants of pages
    - talent
    - blog (insights)
    - enterprise
    - default
*/
// export const Types = {
//   HERO: Styles.hero,
//   PAGES: Styles.pages,
// };

// We memoize the menu in order to prevent it from re-rendering when type is changed
const MemoMenu = memo(Menu);

const Header = memo(({ buttonLabel, analyticsData, isShaded, isBlack, isFixed, isTransparent }) => {
  const [sticky, setSticky] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [ref, inView, entry] = useInView({ threshold: 1 });
  useEffect(() => {
    if (entry) {
      setSticky(!inView);
    }
  }, [inView, entry]);

  const toggleShowMenu = (option) => {
    setShowMenu(option);
  };

  // !isFixed && (sticky || showBackground) && Styles.sticky,
  return (
    <Fragment>
      <div ref={ref} />
      <header
        className={classNames(
          Styles.container,
          isFixed && Styles.isFixed,
          Styles.isOffset,
          isShaded && Styles.isShaded,
          isBlack && Styles.isBlack,
          isTransparent && Styles.isTransparent,
          showMenu && Styles.menuIsOpen
        )}>
        <div className={Styles.wrapper}>
          <div className={Styles.header}>
            <MemoMenu onMenuToggle={toggleShowMenu} {...{ analyticsData, buttonLabel }} />
          </div>
        </div>
      </header>
    </Fragment>
  );
});

Header.propTypes = {
  showBackground: PropTypes.bool,
  variant: PropTypes.number,
  buttonLabel: PropTypes.string,
  analyticsData: PropTypes.object,
};

Header.Styles = Styles;

export default Header;
